import React from 'react';
import { ControlLabel, FormControl, FormGroup } from 'rsuite';

function TextField(props: any) {
  const { name, label, accepter, ...rest } = props;
  return (
    <FormGroup>
      <ControlLabel>{label} </ControlLabel>
      <FormControl name={name} accepter={accepter} {...rest} />
    </FormGroup>
  );
}

export default TextField;